import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { Site } from '@portal-core/sites/models/site.model';

@CollectionStateSelectors({
  stateType: SitesState
})
@State<SitesState>({
  name: SitesState.source,
})
@Service({ autoProvided: false })
export class SitesState extends CollectionStateBase {
  static override source = 'Sites';
  getSource(): string {
    return SitesState.source;
  }
}

@Service()
export class SitesDataService extends CollectionDataServiceBase<Site> {
  protected readonly stateType = SitesState;
}
